const lang = {
  title: '退会処理',
  input_label: '退会理由を教えてください',
  draw_reason: '退会理由',
  button: {
    no_leave: '退会しない',
    withdraw: '退会する'
  },
  modal: {
    header: '退会完了',
    content: 'ご利用ありがとうございました。<br>また次回のご利用をお待ちしています。',
    btn_to_account: 'アカウントページへ'
  }
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/cancelChargePlan.js